<template>
	<div>
		<div v-if="openMenu">
			<ContextMenu :show="openMenu" @open-file-explorer="openFileExplorer" @take-photo="takePhoto" target="file-uploader" @close="closeMenu" />
		</div>
		<div
			id="file-uploader"
			class="drop-area mb-3"
			:class="{ 'cursor-pointer': !dragAndDropDisabled && !disableTypeChange }"
			@click="uploadFile"
			@dragover.prevent
			@drop="onDrop"
		>
			<div :class="maxMobileScreenWidth ? 'd-flex align-items-center' : 'mt-5'">
				<div :class="{ 'my-3': !maxMobileScreenWidth }">
					<svg width="82" height="53" viewBox="0 0 82 53" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M25 20.4521L41 34.0371L56 1.44141L81 51.0183H1L25 20.4521Z"
							stroke="#06263E"
							stroke-opacity="0.45"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<circle cx="26" cy="6" r="4" fill="#1C8280" />
					</svg>
				</div>
				<div :class="{ 'text-start': maxMobileScreenWidth }">
					<h4 class="display-5" v-if="!maxMobileScreenWidth">
						{{ dragAndDropDisabled ? FormMSG(7, 'To import another file') : FormMSG(1, 'Drag and Drop attachments here') }}
					</h4>
					<h6 class="display-6 text-muted mb-5" v-if="!maxMobileScreenWidth">
						{{ dragAndDropDisabled ? FormMSG(8, 'remove the current file') : FormMSG(2, 'or click to browse') }}
					</h6>
					<h6 class="display-6 text-muted" v-if="maxMobileScreenWidth">{{ FormMSG(6, 'Click here to browse files') }}</h6>
					<!-- <p class="text-muted display-6" :class="{ 'pt-4': !maxMobileScreenWidth }">
						<small>{{ FormMSG(3, 'Maximum file size 4MB') }}</small>
					</p> -->
				</div>
			</div>
		</div>
		<div v-if="filesList.length > 0">
			<b-row class="files-background py-2 my-2 rounded" :class="{ 'mx-2': !maxMobileScreenWidth }" v-for="(fileObj, index) in filesList" :key="index">
				<b-col class="d-flex align-items-center justify-content-between" style="gap: 7px">
					<div class="w-auto">
						<svg
							width="35"
							height="35"
							viewBox="0 0 35 35"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							v-if="fileObj.extension.toLowerCase() === 'pdf'"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.2 0C1.88041 0 0 1.88041 0 4.2V30.8C0 33.1196 1.88041 35 4.2 35H30.8C33.1196 35 35 33.1196 35 30.8V4.2C35 1.88041 33.1196 0 30.8 0H4.2ZM6.4314 22.0791C6.5735 22.1764 6.80886 22.225 7.13747 22.225C7.46607 22.225 7.70143 22.1764 7.84352 22.0791C7.98562 21.9818 8.07444 21.8579 8.10996 21.7076C8.14549 21.5484 8.16325 21.3847 8.16325 21.2167V19.4787H9.86845C10.2415 19.4787 10.6189 19.4123 11.0008 19.2796C11.3827 19.1381 11.7335 18.9347 12.0533 18.6693C12.3819 18.3952 12.6439 18.0546 12.8392 17.6478C13.0435 17.2409 13.1456 16.7677 13.1456 16.2282C13.1456 15.6798 13.0435 15.2021 12.8392 14.7953C12.6439 14.3884 12.3819 14.0479 12.0533 13.7737C11.7335 13.4906 11.3827 13.2828 11.0008 13.1501C10.6278 13.0174 10.2548 12.9511 9.88177 12.9511H7.15079C6.82218 12.9511 6.58682 12.9998 6.44473 13.097C6.30263 13.1943 6.21381 13.3226 6.17829 13.4818C6.14276 13.6322 6.125 13.7914 6.125 13.9594V21.2034C6.125 21.3715 6.14276 21.5351 6.17829 21.6943C6.21381 21.8535 6.29818 21.9818 6.4314 22.0791ZM9.88177 17.462H8.16325V14.9677H9.86845C10.1171 14.9677 10.3347 15.0208 10.5212 15.127C10.7166 15.2331 10.8676 15.379 10.9742 15.5648C11.0808 15.7505 11.134 15.9672 11.134 16.2149C11.134 16.5068 11.0674 16.7456 10.9342 16.9313C10.8099 17.1171 10.65 17.2542 10.4546 17.3426C10.2681 17.4222 10.0772 17.462 9.88177 17.462ZM14.327 22.0791C14.4691 22.1764 14.6956 22.225 15.0065 22.225H17.3778C18.035 22.225 18.6389 22.1056 19.1895 21.8668C19.7491 21.628 20.2375 21.3007 20.6549 20.885C21.0724 20.4604 21.3965 19.9651 21.6274 19.399C21.8584 18.8241 21.9738 18.205 21.9738 17.5416C21.9738 16.8871 21.8584 16.2812 21.6274 15.724C21.3965 15.1668 21.0724 14.6803 20.6549 14.2646C20.2375 13.8489 19.7535 13.526 19.2029 13.2961C18.6522 13.0661 18.0572 12.9511 17.4177 12.9511H15.0198C14.6912 12.9423 14.4558 12.9865 14.3137 13.0838C14.1716 13.1811 14.0828 13.3093 14.0473 13.4685C14.0117 13.6189 13.994 13.7781 13.994 13.9462V21.2034C13.994 21.3803 14.0162 21.5484 14.0606 21.7076C14.105 21.8579 14.1938 21.9818 14.327 22.0791ZM17.4177 20.1951H16.0189V14.9677H17.4044C17.8929 14.9677 18.3281 15.0827 18.7099 15.3127C19.0918 15.5338 19.3938 15.8434 19.6158 16.2414C19.8379 16.6394 19.9489 17.0905 19.9489 17.5947C19.9489 18.0988 19.8379 18.5455 19.6158 18.9347C19.3938 19.3239 19.0918 19.6334 18.7099 19.8634C18.3281 20.0845 17.8973 20.1951 17.4177 20.1951ZM23.3325 22.0923C23.4746 22.1808 23.7055 22.225 24.0252 22.225C24.3627 22.225 24.5981 22.1808 24.7313 22.0923C24.8734 21.995 24.9622 21.8712 24.9977 21.7208C25.0332 21.5616 25.051 21.398 25.051 21.2299V18.4305H27.7687C27.9552 18.4305 28.115 18.4173 28.2483 18.3907C28.3904 18.3642 28.5014 18.2934 28.5813 18.1784C28.6612 18.0546 28.7012 17.8512 28.7012 17.5682C28.7012 17.2763 28.6612 17.0684 28.5813 16.9446C28.5014 16.8208 28.3904 16.7456 28.2483 16.719C28.115 16.6925 27.9596 16.6792 27.782 16.6792H25.051V14.9677H27.6742C27.8518 14.9677 28.0161 14.9545 28.1671 14.9279C28.327 14.8926 28.4558 14.8041 28.5535 14.6626C28.6512 14.5211 28.7 14.2911 28.7 13.9727C28.7 13.6366 28.6512 13.3978 28.5535 13.2563C28.4647 13.1147 28.3448 13.0307 28.1938 13.0042C28.0428 12.9688 27.8785 12.9511 27.7009 12.9511H24.0652C23.6744 12.9511 23.4035 13.0219 23.2525 13.1634C23.1016 13.3049 23.0261 13.5703 23.0261 13.9594V21.2167C23.0261 21.3847 23.0394 21.5484 23.066 21.7076C23.1016 21.8668 23.1904 21.995 23.3325 22.0923Z"
								fill="#EA3434"
							/>
						</svg>
						<svg
							width="35"
							height="35"
							viewBox="0 0 35 35"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							v-if="fileObj.extension.toLowerCase() === 'xlsx'"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.2 0C1.8804 0 0 1.88041 0 4.2V30.8C0 33.1196 1.8804 35 4.2 35H30.8C33.1196 35 35 33.1196 35 30.8V4.2C35 1.88041 33.1196 0 30.8 0H4.2ZM22.2705 24.3132C22.4887 24.2362 22.7453 24.0694 23.0405 23.8128C23.4768 23.4406 23.6886 23.1069 23.6758 22.8117C23.6758 22.5166 23.4961 22.1701 23.1367 21.7722L19.4325 17.4467L23.1367 13.129C23.4961 12.744 23.6758 12.3975 23.6758 12.0895C23.6886 11.7815 23.4768 11.4414 23.0405 11.0693C22.7582 10.7998 22.5079 10.6265 22.2897 10.5495C22.0716 10.4725 21.8598 10.4853 21.6545 10.588C21.4492 10.6907 21.2246 10.8896 20.9807 11.1847L17.5254 15.2197L14.07 11.1847C13.8262 10.8896 13.6016 10.6907 13.3963 10.588C13.1909 10.4853 12.9792 10.4725 12.761 10.5495C12.5428 10.6265 12.2926 10.7998 12.0102 11.0693C11.5868 11.4414 11.375 11.7815 11.375 12.0895C11.375 12.3975 11.5547 12.744 11.914 13.129L15.6182 17.4467L11.914 21.7722C11.5547 22.1701 11.375 22.5166 11.375 22.8117C11.375 23.1069 11.5868 23.4406 12.0102 23.8128C12.3054 24.0694 12.5621 24.2362 12.7802 24.3132C12.9984 24.3903 13.2102 24.3774 13.4155 24.2748C13.6208 24.1721 13.839 23.9796 14.07 23.6972L17.5254 19.6697L20.9807 23.6972C21.2246 23.9796 21.4427 24.1721 21.6353 24.2748C21.8406 24.3774 22.0523 24.3903 22.2705 24.3132Z"
								fill="#01AC49"
							/>
						</svg>
						<svg
							width="35"
							height="35"
							viewBox="0 0 35 35"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							v-if="fileObj.extension.toLowerCase() === 'docx'"
						>
							<path d="M30.667 2H9.333A1.333 1.333 0 0 0 8 3.333V9l12 3.5L32 9V3.333A1.333 1.333 0 0 0 30.667 2z" fill="#41a5ee" />
							<path d="M32 9H8v7l12 3.5L32 16z" fill="#2b7cd3" />
							<path d="M32 16H8v7l12 3.5L32 23z" fill="#185abd" />
							<path d="M32 23H8v5.667A1.333 1.333 0 0 0 9.333 30h21.334A1.333 1.333 0 0 0 32 28.667z" fill="#103f91" />
							<path d="M16.667 7H8v19h8.667A1.337 1.337 0 0 0 18 24.667V8.333A1.337 1.337 0 0 0 16.667 7z" opacity=".1" />
							<path d="M15.667 8H8v19h7.667A1.337 1.337 0 0 0 17 25.667V9.333A1.337 1.337 0 0 0 15.667 8z" opacity=".2" />
							<path d="M15.667 8H8v17h7.667A1.337 1.337 0 0 0 17 23.667V9.333A1.337 1.337 0 0 0 15.667 8z" opacity=".2" />
							<path d="M14.667 8H8v17h6.667A1.337 1.337 0 0 0 16 23.667V9.333A1.337 1.337 0 0 0 14.667 8z" opacity=".2" />
							<path
								d="M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z"
								fill="#185abd"
							/>
							<path d="M11.95 21h-1.8l-2.1-6.9-2.2 6.9h-1.8l-2-10h1.8l1.4 7 2.1-6.8h1.5l2 6.8 1.4-7h1.7z" fill="#fff" />
							<path d="M0 0h32v32H0z" fill="none" />
						</svg>
						<svg
							width="35"
							height="35"
							viewBox="0 0 14 14"
							fill="white"
							xmlns="http://www.w3.org/2000/svg"
							preserveAspectRatio="none"
							v-if="
								fileObj.extension.toLowerCase() === 'png' ||
								fileObj.extension.toLowerCase() === 'jpg' ||
								fileObj.extension.toLowerCase() === 'jpeg' ||
								fileObj.extension.toLowerCase() === 'heic'
							"
						>
							<path
								d="M1.5 12H12.5C13.0523 12 13.5 11.5523 13.5 11V3C13.5 2.44771 13.0523 2 12.5 2H1.5C0.947715 2 0.5 2.44771 0.5 3V11C0.5 11.5523 0.947715 12 1.5 12Z"
								stroke="#64748b"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9.50191 6.21206C10.1896 6.21206 10.7471 5.65457 10.7471 4.96687C10.7471 4.27917 10.1896 3.72168 9.50191 3.72168C8.81421 3.72168 8.25671 4.27917 8.25671 4.96687C8.25671 5.65457 8.81421 6.21206 9.50191 6.21206Z"
								stroke="#facc15"
								fill="#fef08a"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9.08269 12.0001C8.77218 10.3462 7.88415 8.85646 6.57706 7.79666C5.26997 6.73685 3.62885 6.17593 1.94652 6.21397C1.46114 6.21268 0.976755 6.25789 0.5 6.34898"
								stroke="#64748b"
								fill="#cbd5e1"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M13.5 8.94077C12.7123 8.67478 11.8865 8.53934 11.0551 8.53981C10.0028 8.53753 8.96111 8.75052 7.99414 9.1657"
								stroke="#64748b"
								fill="#cbd5e1"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
					<div class="d-flex align-items-center flex-wrap" style="gap: 7px" :class="maxMobileScreenWidth ? 'w-75' : 'flex-grow-1'">
						<span class="flex-nowrap" :class="{ 'text-overflow w-100': maxMobileScreenWidth, 'w-50': !maxMobileScreenWidth }">{{
							fileObj.file.name
						}}</span>
						<div class="w-auto" v-if="!fileObj.processed">
							<b-spinner variant="dark" small></b-spinner>
						</div>
						<v-select
							class="flex-grow-1"
							label="text"
							v-model="fileObj.type"
							:options="getTypesMenu"
							:reduce="(option) => option.value"
							:placeholder="FormMSG(4, 'Select document type')"
							:disabled="disableTypeChange"
							appendToBody
							v-if="forSingle"
						></v-select>
					</div>
					<div class="w-auto">
						<b-button
							:size="maxMobileScreenWidth ? 'sm' : 'md'"
							variant="light"
							v-b-tooltip.hover="FormMSG(5, 'Remove file')"
							@click="removeFile(index)"
							:disabled="!fileObj.processed"
						>
							<component :is="getLucideIcon('XCircle')" :size="maxMobileScreenWidth ? 16 : 24" color="#999999" />
						</b-button>
					</div>
				</b-col>
			</b-row>
		</div>
		<input
			type="file"
			ref="fileInput"
			style="display: none"
			@change="handleFiles"
			:multiple="canAddMultipleFiles"
			:disabled="dragAndDropDisabled || disableTypeChange"
			:accept="imagesExtension"
		/>
	</div>
</template>

<script>
import ContextMenu from './ContextMenu.vue';
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';
// helpers
import { getFileExtension } from '~helpers';
import { Camera, CameraResultType } from '@capacitor/camera';
// constants
import { INVOICE_MENUS, INVOICE_ATTACHEMENTS_TYPE } from '@/shared/constants';

export default {
	name: 'FilesUploader',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	data() {
		return {
			imagesExtension: '.png,.jpg,.jpeg,.heic,.pdf',
			imagesExtensionList: ['png', 'jpg', 'jpeg', 'heic', 'pdf'],
			openMenu: false
		};
	},
	components: {
		ContextMenu
	},
	props: {
		filesList: {
			type: Array,
			default: () => []
		},
		disableTypeChange: {
			type: Boolean,
			default: false
		},
		forSingle: {
			type: Boolean,
			default: true
		},
		isFromFinalForm: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		getTypesMenu() {
			return this.FormMenu(INVOICE_MENUS.ATTACHEMENTS_TYPE);
		},
		canAddMultipleFiles() {
			return (this.forSingle && this.isFromFinalForm) || !this.forSingle;
		},
		dragAndDropDisabled() {
			return this.forSingle && this.filesList.length > 0 && !this.isFromFinalForm;
		}
	},
	methods: {
		provideType(fileIndex) {
			if (this.forSingle && (this.filesList.length > 0 || (this.filesList.length === 0 && fileIndex !== 0))) {
				return INVOICE_ATTACHEMENTS_TYPE.OTHER;
			} else {
				return INVOICE_ATTACHEMENTS_TYPE.INVOICE;
			}
		},
		createFileObj(file, fileIndex) {
			return {
				file: file,
				extension: getFileExtension(file.name),
				type: this.provideType(fileIndex),
				xid: '',
				processed: this.isFromFinalForm ? true : false
			};
		},
		retrieveUploadedFiles(files) {
			const newList = [];
			Array.from(files).forEach((file, index) => {
				newList.push(this.createFileObj(file, index));
			});
			this.$emit('add', newList);
		},
		async convertWebPathToFile(webPath) {
			const response = await fetch(webPath);
			const blob = await response.blob();
			const timestamp = Date.now();
			const fileName = `invoice_${timestamp}.jpg`;
			return new File([blob], fileName, { type: blob.type });
		},
		async clickAddByPicturePwa() {
			const photo = await Camera.getPhoto({
				resultType: CameraResultType.Uri,
				allowEditing: false,
				quality: 100
			});
			const imageFile = await this.convertWebPathToFile(photo.webPath);
			this.retrieveUploadedFiles([imageFile]);
		},
		takePhoto() {
			this.clickAddByPicturePwa();
			this.closeMenu();
		},
		uploadFile() {
			if (!this.$isAndroidDevice()) {
				this.openFileExplorer();
			} else {
				this.openMenu = true;
			}
		},
		openFileExplorer() {
			this.$refs.fileInput.click();
			this.closeMenu();
		},
		closeMenu() {
			this.openMenu = false;
		},
		onDrop(event) {
			if (this.dragAndDropDisabled || this.disableTypeChange) return;
			// Prevent default handling of the event
			event.preventDefault();
			// Get the files from the dropped event
			const files = event.dataTransfer.files;
			this.retrieveUploadedFiles(files);
		},
		handleFiles(event) {
			const files = event.target.files;
			this.retrieveUploadedFiles(files);
			this.$refs.fileInput.value = '';
		},
		removeFile(index) {
			// this.filesList.splice(index, 1);
			this.$emit('remove', index);
		}
	}
};
</script>

<style scoped>
.drop-area {
	border: 1px dashed #ccc;
	padding: 20px 20px 0px 20px;
	text-align: center;
	border-radius: 5px;
	height: 300px;
}
@media only screen and (max-width: 600px) {
	.drop-area {
		height: 100px !important;
	}
}
.text-overflow {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
:deep(.files-background) {
	background-color: rgba(226, 230, 235, 0.54);
}
</style>
